import { service } from '@/ajax/request'
import { AxiosPromise } from 'axios'

//总公司管理人员查询
export const manager = (): AxiosPromise => (
  service({
    url: '/member/operation/company/manager',
    method: 'get',
    type: 'form'
  })
)

//批量保存总公司管理员
export const saveManager = (params:any): AxiosPromise => (
  service({
    url: '/member/operation/company/saveManager',
    method: 'post',
    params
  })
)

//删除的类型 2:分公司，3:服务队, 4:运营官(删除的会员id：memberId)
export const deleteOperation = (params:any): AxiosPromise => (
  service({
    url: `/member/operation/deleteOperation${params.roleType}`,
    method: 'get',
    type: 'form',
    params
  })
)

//入驻会员解除运营官绑定, operationId:对应的运营官会员id, 对应的用户会员id(微信) memberId
export const deleteRelationOperationMember = (params:any): AxiosPromise => (
  service({
    url: `/member/operation/deleteRelationOperationMember`,
    method: 'post',
    type: 'form',
    params
  })
)


//1：总公司，2:分公司，3:服务队, 4:运营官 memberId
export const selectOperation = (params:any): AxiosPromise => (
  service({
    url: `/member/operation/selectOperation/${params.roleType}`,
    method: 'get',
    type: 'form',
    params
  })
)

//根据名称或数据号查询运营官信息 param：{名称或者手机号}
export const queryOperationMember = (params:any): AxiosPromise => (
  service({
    url: `/member/operation/queryOperationMember`,
    method: 'get',
    type: 'form',
    params
  })
)

//入驻会员关联运营官
export const relationOperationMember = (params:any): AxiosPromise => (
  service({
    url: `/member/operation/relationOperationMember`,
    method: 'get',
    params
  })
)

//添加或修改服务队
export const saveOperationService = (params:any): AxiosPromise => (
  service({
    url: `/member/operation/saveOperationService`,
    method: 'post',
    type: 'newForm',
    params
  })
)

//添加或修改子公司
export const saveSubCompany = (params:any): AxiosPromise => (
  service({
    url: `/member/operation/saveSubCompany`,
    method: 'post',
    type: 'newForm',
    params
  })
)


export const queryList = (): AxiosPromise => (
  service({
    url: '/member/operation/list',
    method: 'get',
    type: 'form'
  })
)

// 查询服务队看板数据
export const queryOperationOrderBoard = (params:any): AxiosPromise => (
  service({
    url: '/member/operation/queryOperationOrderBoard',
    method: 'get',
    type: 'form',
    params
  })
)

// 服务队看板数据汇总数据
export const queryOperationBoardAggregate = (): AxiosPromise => (
  service({
    url: '/member/operation/queryOperationBoardAggregate',
    method: 'get',
    type: 'form'
  })
)

// 运营官是否绑定用户,返回true表示存在不能删除，返回false表示不存在可以删除
export const isExistOperationMember = (params:any): AxiosPromise => (
  service({
    url: '/member/operation/isExistOperationMember',
    method: 'post',
    type: 'form',
    params
  })
)